import { ChangeEvent, useCallback, useState } from "react";
import { searchCustomer } from "src/apis/customerApi";
import { ItemDto } from "src/types/base";


import useUiuxStore from "src/store/useUiuxStore";
import { defaultSAL2030_R01Filter, useSAL2030_R01Store } from "src/containers/mes/SAL/SAL2030_R01/Store_SAL2030_R01";

import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { getItemPopupList } from "src/apis/itemApi";

export const SearchSection_SAL2030_R01 = () => {
	const { SAL2030_R01Filter, setSAL2030_R01Filter } = useSAL2030_R01Store();

	const { setCodeSearchModalProps } = useUiuxStore();
	const { compCdList } = useCommonCodeStore();

	// 달력 팝업 노출 여부 상태
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
	
	const custInfoHandleFoucsId = 'infoCustInput_search';
	const itemInfoHandleFoucsId = 'infoItemInput_search';

	// 사업장(회사) 선택 핸들러
	const handleFilterCompanyChange = (selectedValue: string) => {
		setSAL2030_R01Filter({ compCd: selectedValue });
	}
	
	// Info 폼 코드 검색 필드 설정
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			},
			extraFilter: () => ({
				customCd: SAL2030_R01Filter.customCd || '',
				customNm: SAL2030_R01Filter.customNm || '',
			}),
		},
		{
			fieldName: 'itemCd',
			category: '품목',
			focusId: itemInfoHandleFoucsId,
			responseMapping: {
				itemCd: 'itemCd',
				itemNm: 'itemNm',
			},
			searchFunction: async (searchText: string) => {
				const itemResponse = await getItemPopupList(searchText, '', '', '');
				return itemResponse.data.data.find(value => value.itemCd === searchText);
			},
			extraFilter: () => ({
				itemCd: SAL2030_R01Filter.itemCd || '',
				itemNm: SAL2030_R01Filter.itemNm || '',
			}),
		}
	];

	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers } = useInfoFormEvents({
		editData: SAL2030_R01Filter,
		setEditData: setSAL2030_R01Filter,
		defaultData: defaultSAL2030_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'SAL2030_R01_search'
	});

	// UI 렌더링
	return (
		<>
		<SearchSectionForm>
			{/* 사업장(회사) 선택 영역 */}
			<SearchDropDownForm
				label="사업장"
				value={SAL2030_R01Filter.compCd}
				optionList={compCdList}
				onChangeValue={handleFilterCompanyChange}
			/>
			<SearchDateRangeForm
				label="매출일자"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				dateRange={SAL2030_R01Filter.dateRange}
				setDateRange={(dateRange) => setSAL2030_R01Filter({ dateRange: dateRange })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
			{/* 거래처 입력 및 검색 영역 */}
			<SearchCodeModalForm
				label="거래처"
				value={SAL2030_R01Filter.customCd}
				valueLabel={SAL2030_R01Filter.customNm}
				handleFoucsId={custInfoHandleFoucsId}
				onChange={getFieldHandlers('customCd').onChange}
				onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
				onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
			/>
			{/* 품목코드 입력 및 검색 영역 */}
			<SearchCodeModalForm
				label="품목코드"
				value={SAL2030_R01Filter.itemCd}
				valueLabel={SAL2030_R01Filter.itemNm}
				handleFoucsId={itemInfoHandleFoucsId}
				onChange={getFieldHandlers('itemCd').onChange}
				onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
				onKeyDown={getFieldHandlers('itemCd').onEnterKeyDown}
			/>
		</SearchSectionForm>
		</>
	)
}

export default SearchSection_SAL2030_R01;

